import { createFeatureSelector, createSelector } from "@ngrx/store";
import { RegionalState } from "./regional-setting.state";

export const RegionalFeatureSelector = createFeatureSelector<RegionalState>('regionalSetting');

export const SelectRegionalSettings = createSelector(
  RegionalFeatureSelector,
  state => state
)
export const SelectRegionalCountry = createSelector(
  RegionalFeatureSelector,
  state => state.country
)
export const SelectRegionalCurrency = createSelector(
  RegionalFeatureSelector,
  state => state.currency
)
export const SelectRegionalLanguage = createSelector(
  RegionalFeatureSelector,
  state => state.language
)